import React    from 'react';
import moment   from 'moment';
import {Button} from 'semantic-ui-react';

const goToBack = (toolbar) => toolbar.onNavigate('PREV');

const goToNext = (toolbar) => toolbar.onNavigate('NEXT');

const goToCurrent = (toolbar) => toolbar.onNavigate('TODAY');

const ToolBarCalendar = (toolbar) => {
  const label = () => {
    const date = moment(toolbar.date);
    return (
      <span><b>{date.format('MMMM')}</b><span> {date.format('YYYY')}</span></span>
    );
  };

  const handleClick = [
    () => goToBack(toolbar),
    () => goToCurrent(toolbar),
    () => goToNext(toolbar),
  ];

  return (
    <div className='toolbar-container'>
      <label className='label-date'>
        {label()}
      </label>

      <div className='back-next-buttons'>
        <Button
          className='btn-back'
          onClick={handleClick[0]}
        >
          {'Prev'}
        </Button>

        <Button
          className='btn-current'
          onClick={handleClick[1]}
        >
          {'Today'}
        </Button>

        <Button
          className='btn-next'
          onClick={handleClick[2]}
        >
          {'Next'}
        </Button>
      </div>
    </div >
  );
};

{/* ToolBarCalendar.propTypes = propTypes;
ToolBarCalendar.defaultPropTypes = defaultProps; */}

export default ToolBarCalendar;



// WEBPACK FOOTER //
// ./src/molecules/ToolBarCalendar/ToolBarCalendar.js